<template>
    <a11y-dialog
            @dialog-ref="assignDialogRef"
            app-root="#calendar"
            close-button-label="Close"
            dialog-root="#modal-root"
            id="app-dialog"
    >
        <div class="c-modal__wrap" v-html="content"></div>

        <template v-slot:closeButtonContent>
            <span>Close</span>
        </template>

    </a11y-dialog>
</template>

<script>
    import {EventBus} from "../event-bus"
    import {A11yDialog} from "vue-a11y-dialog"
    import jQuery from 'jquery'

    export default {
        name: "Modal",
        components: {
            "a11y-dialog": A11yDialog
        },
        data() {
            return {
                dialog: null,
                content: '',
                contentCache: {}
            }
        },
        mounted() {
            EventBus.$on('calendar:open-modal', this.updateContent)
        },
        methods: {
            assignDialogRef(dialog) {
                this.dialog = dialog;
                this.dialog.on('show', (dialogEl, event) => {
                    document.body.classList.add('modal-open');
                    this.$parent.isLoading = false
                });

                this.dialog.on('hide', (dialogEl, event) =>{
                    document.body.classList.remove('modal-open');
                    this.$parent.isLoading = false
                });
            },
            updateContent(date) {
                if (this.contentCache.hasOwnProperty(date)) {
                    this.content = this.contentCache[date]
                    this.openDialog()
                } else {
                    this.fetchInstances(date)
                }
            },
            fetchInstances(date) {
                jQuery.ajax({
                    url: window.ajax.url,
                    method: 'GET',
                    dataType: 'json',
                    data: {
                        action: 'basethemeCalendarInstancesForDate',
                        date: date
                    },
                }).done((data) => {
                    this.content = data.content
                    this.contentCache[date] = this.content
                    this.$parent.isLoading = false
                    this.openDialog()
                })
            },
            openDialog() {
                if (this.dialog) {
                    this.dialog.show();
                }
            },
        }

    }
</script>

<style scoped>

</style>
